<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>CASA</span>
        <span class="font-weight-light"> Agentes</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="mr-2">Validación de agente</span>
    </v-toolbar>

    <v-content>
      <UserValidation/>
    </v-content>
  </v-app>
</template>

<script>
import UserValidation from './components/UserValidation'

export default {
  name: 'App',
  components: {
      UserValidation
  },
  data () {
    return {
      //
    }
  }
}
</script>
